import {buildPeriods,londonDay} from './stockHistory';
export const metricColour={bad:'#fb7185',good:'#34d399',required:'#fbbf24',calls:'#c084fc',eligible:'#38bdf8'};
export function changeColour(delta,metric,mode='quantity') {
  if(delta==null || delta===0)return '#94a3b8';
  const direction=mode==='workload' && ['bad','required','calls'].includes(metric)?-delta:delta;
  return direction>0?'#34d399':'#fb7185';
}
export function compareStockParts(before,after,metric) {
  const a=new Map(before.map(r=>[r.part_id,r])),b=new Map(after.map(r=>[r.part_id,r]));
  return [...new Set([...a.keys(),...b.keys()])].map(partId=>{
    const open=Number(a.get(partId)?.[metric])||0,close=Number(b.get(partId)?.[metric])||0;
    return {partId,open,close,delta:close-open,percent:open!==0?(close-open)/Math.abs(open)*100:null,status:!a.has(partId)?'Newly present':!b.has(partId)?'No longer present':close===open?'Unchanged':'Changed'};
  }).sort((x,y)=>Math.abs(y.delta)-Math.abs(x.delta)||x.partId.localeCompare(y.partId));
}
export async function loadComparisonParts(api,id,isCancelled=()=>false) {
  const rows=[];
  for(let page=0;;page++) {
    if(isCancelled())return null;
    const result=await api.parts(id,'',page);
    if(isCancelled())return null;
    if(!Array.isArray(result?.rows) || (result.rows.length===0 && result.count>rows.length))throw new Error('Part comparison is incomplete; retry Refresh.');
    rows.push(...result.rows);
    if(result.count!=null?rows.length>=result.count:result.rows.length<100)return rows;
  }
}
export function summarizeStock(rows,metric,from,to) {
  const ordered=[...rows].sort((a,b)=>a.observed_at.localeCompare(b.observed_at)||(a.created_at||'').localeCompare(b.created_at||'')||String(a.id).localeCompare(String(b.id)));
  const inside=ordered.filter(s=>londonDay(s.observed_at)>=from && londonDay(s.observed_at)<=to);
  const periods=buildPeriods(ordered,'day',from,to);
  const opening=ordered[0],closing=ordered[ordered.length-1];
  const open=opening?Number(opening.totals[metric])||0:null,close=closing?Number(closing.totals[metric])||0:null;
  const values=inside.map(s=>Number(s.totals[metric])||0);
  const comparisons=periods.reduce((n,p)=>n+p.comparisons,0);
  let changedReports=0,biggestRise=0,biggestFall=0;
  for(let i=1;i<ordered.length;i++) {
    const a=ordered[i-1],b=ordered[i],date=londonDay(b.observed_at);
    if(date<from || date>to || a.scope_hash!==b.scope_hash || a.team!==b.team || a.kind!==b.kind || b.kind==='parsed')continue;
    const delta=(Number(b.totals[metric])||0)-(Number(a.totals[metric])||0);
    if(delta)changedReports++;
    biggestRise=Math.max(biggestRise,delta);biggestFall=Math.max(biggestFall,-delta);
  }
  const endpoint=inside.length && opening?.id!==closing?.id?close-open:null;
  return {open,close,endpoint,percent:endpoint!==null && open!==0?endpoint/Math.abs(open)*100:null,
    net:comparisons?periods.reduce((n,p)=>n+p.change[metric],0):null,
    increase:periods.reduce((n,p)=>n+p.increase[metric],0),decrease:periods.reduce((n,p)=>n+p.decrease[metric],0),
    average:values.length?values.reduce((a,b)=>a+b,0)/values.length:null,low:values.length?Math.min(...values):null,high:values.length?Math.max(...values):null,
    reports:inside.length,days:periods.length,comparisons,changedReports,biggestRise,biggestFall,
    baselines:periods.reduce((n,p)=>n+p.baselines,0),scopeChanged:ordered.some((s,i)=>i>0&&s.scope_hash!==ordered[i-1].scope_hash),opening,closing};
}
